import { render } from "./SimpleEmail.vue?vue&type=template&id=c703f9c2&ts=true"
import script from "./SimpleEmail.vue?vue&type=script&lang=ts"
export * from "./SimpleEmail.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__